export default __webpack_public_path__ + "static/media/iPadSS8.c4d9fd79.png";